import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { LegalPageLayout } from "@/components/LegalPageLayout";

export const Route = createFileRoute("/faq")({
  head: () => ({
    meta: [
      { title: "FAQ — Payment Protection, verification & payouts | Lumvio" },
      { name: "description", content: "Answers about Lumvio's Payment Protection, identity verification, invoices, refunds, disputes and freelancer payouts." },
      { name: "keywords", content: "Lumvio FAQ, freelance payment protection questions, freelancer verification, freelance payouts, refunds and disputes" },
      { property: "og:title", content: "FAQ — Payment Protection, verification & payouts | Lumvio" },
      { property: "og:description", content: "Common questions about Payment Protection, verification, invoices and payouts on Lumvio." },
      { property: "og:url", content: "https://lumvio.co/faq" },
    ],
    links: [
      { rel: "canonical", href: "https://lumvio.co/faq" },
      { rel: "alternate", hrefLang: "en", href: "https://lumvio.co/faq" },
      { rel: "alternate", hrefLang: "ar", href: "https://lumvio.co/faq" },
      { rel: "alternate", hrefLang: "x-default", href: "https://lumvio.co/faq" },
    ],

  }),
  component: FaqPage,
});

type FaqItem = { q: string; a: string; linkLabel?: string; linkTo?: string };

function FaqPage() {
  const { t } = useTranslation();
  const items = t("faqPage.items", { returnObjects: true }) as FaqItem[];
  return (
    <LegalPageLayout title={t("faqPage.title")} updated={t("faqPage.updated")}>
      {items.map((it, i) => (
        <div key={i}>
          <h2>{it.q}</h2>
          <p>
            {it.a}
            {it.linkLabel && it.linkTo ? (
              <>
                {" "}
                <Link to={it.linkTo}>{it.linkLabel}</Link>
              </>
            ) : null}
          </p>
        </div>
      ))}
    </LegalPageLayout>
  );
}
